import script from "./OpsMysqlMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsMysqlMonitor.vue?vue&type=script&setup=true&lang=js"

import "./OpsMysqlMonitor.vue?vue&type=style&index=0&id=00b7a626&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b7a626"]])

export default __exports__